module.exports = "/packs/bg_concept_sp-d700f5dcea28a583928d85c286ef3d99.png";